// ArrivalTime.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Kalkulator Waktu Tempuh - Menghitung Waktu Tempuh Berdasarkan Kecepatan dan Jarak";
const DESCRIPTION =
  "Hitung waktu tempuh dengan akurat! Kalkulator kecepatan dan jarak memperkirakan waktu kedatangan dalam menit dan jam - ideal untuk perjalanan, pengiriman, olahraga, atau benda bergerak lainnya. Masukkan jarak dan kecepatan, dapatkan hasilnya segera!";
const KEYWORDS = "waktu tempuh, menghitung waktu tempuh, kalkulator waktu";
const OG_URL = "https://do-calculate.com/calculator/id/arrivaltime";
function Calculator() {
  const [distance, setDistance] = useState("");
  const [speed, setSpeed] = useState("");
  const [arrivalTime, setArrivalTime] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!distance || !speed) {
      setError("Harap masukkan jarak dan kecepatan dengan benar");
      setArrivalTime("");
      return;
    }
    const distanceValue = parseFloat(distance);
    const speedValue = parseFloat(speed);
    if (isNaN(distanceValue) || isNaN(speedValue) || speedValue <= 0) {
      setError("Harap masukkan nilai yang valid dan positif untuk jarak dan kecepatan");
      setArrivalTime("");
      return;
    }
    const arrivalTimeValue = distanceValue / speedValue;
    setArrivalTime(arrivalTimeValue.toFixed(2));
    setError("");
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Untuk menghitung waktu tempuh, kita perlu mengetahui jarak yang akan ditempuh
                  dan kecepatan benda bergerak.
                </p>
                <p>
                  Kita dapat menghitung waktu kedatangan seseorang, truk, mobil, atau benda bergerak lainnya dengan
                  menentukan kecepatan benda bergerak tersebut, baik manusia, kendaraan, atau kereta api, dan menghitung serta mengetahui jarak yang akan ditempuh benda tersebut. Ketika kita menghitung
                  kecepatan benda bergerak dan jarak yang ditempuh, kita dapat menghitung waktu dari:
                </p>
                <p>
                  <b>Waktu = Jarak tempuh / Kecepatan benda</b>
                </p>
                <p>
                  Dengan mengetahui waktu yang dibutuhkan benda untuk sampai, kita dapat mengetahui pada waktu
                  tertentu kapan benda akan sampai di titik yang dituju..
                </p>
                <p>
                  Gunakan kalkulator berikut untuk menghitung waktu tempuh berdasarkan kecepatan dan jarak
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div >
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Jarak (kilometer)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="80"
                        value={distance}
                        onChange={(e) => setDistance(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Kecepatan (kilometer/jam)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="8"
                        value={speed}
                        onChange={(e) => setSpeed(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Hitung Waktu Tempuh
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Kesalahan: {error}
                      </p>
                    ) : (
                      <>
                        {arrivalTime !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              Waktu Tempuh (jam): {arrivalTime} jam
                            </p>
                            <p className="p-3 mb-2 bg-info text-black">
                              Langkah-langkah penyelesaian: <br />- Hitung waktu berdasarkan
                              rumus berikut: Waktu (jam) = Jarak (kilometer) /
                              Kecepatan (kilometer/jam) - Kemudian bagi jarak yang
                              harus ditempuh dengan kecepatan untuk mendapatkan waktu akhir.
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;